import React from 'react';
import { Alert, Form } from 'react-bootstrap';

import { CreateUpdateCompanyDto } from '../../../common/pokCore/autogenerated/pokApiClient';
import FormRow from '../../../app/components/FormRow';
import CurrencySelector from '../Selects/CurrencySelector';
import { useTranslation } from '../../../common/hooks/useTranslation';
import { NewDatePicker } from '../../../app/components/NewDatePicker';
import { TooltipKey } from '../../../common/pokCore/tooltip.enum';

interface CompanySensitiveDataTabProps {
  company: CreateUpdateCompanyDto;
  propertyChange: (obj: Partial<CreateUpdateCompanyDto>) => void;
  minProjectDate: string;
}

export const CompanySensitiveDataTab: React.FC<
  CompanySensitiveDataTabProps
> = ({ company, propertyChange, minProjectDate }) => {
  const { t, tk } = useTranslation('administrationLng');

  return (
    <>
      <Alert variant="danger" className="mb-3">
        {t(tk.administration.sensitiveDataWarning)}
      </Alert>
      <Form className="d-grid gap-3">
        <FormRow controlId="currency" label={t(tk.common.currency)}>
          <CurrencySelector
            value={company?.mainCurrencyId || ''}
            onChange={option =>
              propertyChange({ mainCurrencyId: option.value })
            }
          />
        </FormRow>
        <FormRow
          controlId="pathPhase"
          label={t(tk.administration.pathPhase)}
          tooltipKey={TooltipKey.pathPhaseCompanyTooltip}
          className="mt-3"
        >
          <Form.Check
            type="checkbox"
            className="pt-2"
            checked={company.pathPhase || false}
            onChange={e => propertyChange({ pathPhase: e.target.checked })}
          />
        </FormRow>
        <FormRow
          controlId="showMargin"
          label={t(tk.administration.showMargin)}
          className="mt-3"
        >
          <Form.Check
            type="checkbox"
            className="pt-2"
            checked={company.showMargin || false}
            onChange={e => propertyChange({ showMargin: e.target.checked })}
          />
        </FormRow>
        <FormRow
          controlId="symphonyHandel"
          label={t(tk.administration.symphonyHandel)}
          className="mt-3"
        >
          <Form.Check
            type="checkbox"
            className="pt-2"
            checked={company.symphonyHandel || false}
            onChange={e => propertyChange({ symphonyHandel: e.target.checked })}
          />
        </FormRow>
        <FormRow
          controlId="eod"
          label={t(tk.administration.eod)}
          className="mt-3"
        >
          <Form.Check
            type="checkbox"
            className="pt-2"
            checked={company.eod || false}
            onChange={e => propertyChange({ eod: e.target.checked })}
          />
        </FormRow>
        <FormRow
          controlId="KSeF"
          label={t(tk.administration.ksef)}
          className="mt-3"
        >
          <NewDatePicker
            value={company.ksef || undefined}
            dateChanged={date => propertyChange({ ksef: date })}
            min_date={minProjectDate}
          />
        </FormRow>
      </Form>
    </>
  );
};
